import Bridge from '../lib/Bridge'
import axios from 'axios'
import { getEnvHost } from '../tools/getPlatform'
import { loadScript } from '../tools/loadScript'
import { getPlatform } from '../tools/getPlatform'
// const mobileSite = getEnvHost('//m.xinli001.com')
// console.log(mobileSite)

const shareMatchKeys = {
  onMenuShareTimeline: '朋友圈',
  onMenuShareAppMessage: '微信',
  onMenuShareQQ: 'qq',
  onMenuShareWeibo: '腾讯微博',
  onMenuShareQZone: 'qq空间',
  hideMenuItems: '隐藏部分按钮',
  hideAllNonBaseMenuItem: '隐藏所有非基础按钮接口',
  updateAppMessageShareData: '自定义“分享给朋友”及“分享到QQ”按钮的分享内容',
  updateTimelineShareData: '自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容'
}
/**
 * 微信分享，包括微信浏览器和native app 此方法在原来页面抽离
 */
const wechatShareMixin = {
  data() {
    return {
      // 根据wxconfig变化获取的wx-package
      wxConfig: null
    }
  },
  computed: {
    // 获取授权列表
    shareLinsters() {
      return [
        'onMenuShareTimeline', // 朋友圈
        'onMenuShareAppMessage', // 微信
        'onMenuShareQQ', // qq
        'onMenuShareWeibo', // 腾讯微博
        'onMenuShareQZone', // qq空间
        'hideMenuItems', //隐藏部分按钮
        'hideAllNonBaseMenuItem', //隐藏所有非基础按钮接口
        'updateAppMessageShareData', // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容（1.4.0）
        'updateTimelineShareData' // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容（1.4.0）
      ]
    },
    // 分享信息
    shareConfig() {
      console.warn('请定义computed.shareConfig return微信分享, 可配置项目如下')
      console.log(`{
        title,
        desc,
        link,
        imgUrl,
        success = () => {},
        cancel = () => {},
        type = '',
        dataUrl = ''
      }`)
      return {}
    },
    // 微信二次分享隐藏部分按钮
    hideConfig() {
      console.warn('请定义computed.hideConfig , 可配置项目如下')
      console.log(`{
       menuList:[] // 需要隐藏的按钮
      }`)
      return {}
    },
    // 微信二次分享是否需要隐藏微信分享所有非基础按钮接口
    hideAllNonBaseMenuItemConfig() {
      console.warn(
        '请定义computed.hideAllNonBaseMenuItemConfig , 可配置项目如下'
      )
      console.log(`{
       hideAllNonBaseMenuItem: false // 是否需要隐藏微信分享所有非基础按钮接口，true 隐藏，false不隐藏,不传默认是false
      }`)
      return {}
    },
    wxfetchParams() {
      return {}
    },
    // brige初始话时methods需要合并的配置项
    // otherBrigeMethods() {
    //   return []
    // },
    // topFuncBtnConfig btnlist需要合并的配置项
    // otherBtnConfig() {
    //   return []
    // }
    isAutoSetBrowserShare() {
      return true
    }
  },
  methods: {
    wxReady() {},
    mixinShareStat(properties = {}) {
      const { business, pageName } = this.$route.meta
      // 没定义就不继续了
      if (!business) {
        console.warn(
          '微信分享mixin警告：路由没有定义meta.business, pageName， 埋点失败'
        )
        return
      }

      const { link, title, desc } = this.shareConfig
      const _properties = {
        href: window.location.href,
        UA: window.navigator.userAgent,
        页面title: document.title,
        title: pageName || '',
        App版本: this.$route.query._version || '',
        社交类型: '分享',
        分享目标: properties.channel || '',
        分享标题: title,
        分享描述: desc,
        分享链接: link
      }
      this.$stat.send({
        name: `${business}-社交行为`,
        properties: _properties
      })
    },
    // 微信浏览器
    setBrowserShare() {
      const mobileSite = getEnvHost('//m.xinli001.com')
      const reqUrl_getWxConfig = mobileSite + '/wx/get-wx-package.json'
      if (navigator.userAgent.toUpperCase().indexOf('MICROMESSENGER') !== -1) {
        let currentUrl = document.location.href.split('#')[0]
        axios
          .get(reqUrl_getWxConfig + '?url=' + encodeURIComponent(currentUrl), {
            params: this.wxfetchParams
          })
          .then(res => {
            // 测试环境这里和线上返回的res格式不一样，需要作判断
            let data = {}
            if (res.hasOwnProperty('code')) {
              data = res
            } else {
              data = res.data
            }
            if (data.code == 0) {
              // 出发watchs
              this.wxConfig = data.data
            }
          })
      }
    },
    /**
     * native app 外部手动调用
     * @param {object} bridge new Bridge 时候传入的配置，会合并methods
     * @param {object} topFuncBtnConfigBtnList bridge.call topFuncBtnConfig 时候传入的配置
     */
    setNativeShare(bridgeConfig = {}, topFuncBtnConfigBtnList = []) {
      // H5与原生交互
      if (navigator.userAgent.indexOf('yixinliApp') >= 0) {
        window.shareCallback = opt => {
          try {
            const { success } = this.shareConfig
            opt = JSON.parse(opt)
            typeof success === 'function' && success()
            this.mixinShareStat({
              channel: opt.shareChannel || ''
            })
          } catch (e) {
            console.log(`分享失败`, e)
          }
        }
        bridgeConfig = {
          ...bridgeConfig,
          methods: [
            ...(bridgeConfig.methods || []),
            {
              method: 'topFuncBtn',
              callback: ops => {
                if (ops.name === 'shareReportBtn') {
                  var share_config = () => {
                    const { title, desc, link, imgUrl } = this.shareConfig
                    return {
                      title,
                      desc,
                      link,
                      imgUrl,
                      callbackName: 'shareCallback'
                    }
                  }
                  bridge.call('shareReport', share_config())
                }
              }
            }
          ]
        }
        console.log('bridgeConfig', bridgeConfig)

        var bridge = new Bridge(bridgeConfig)
        bridge.call('topFuncBtnConfig', {
          btnList: [
            {
              name: 'shareReportBtn',
              visible: 1
            },
            ...topFuncBtnConfigBtnList
          ]
        })
        this.bridge = bridge
      }
    },
    wxShareConfig(shareConfig) {
      const isWechat = getPlatform().isWechat
      if (!isWechat || typeof wx !== 'object') {
        return
      }
      const { shareLinsters, hideConfig, hideAllNonBaseMenuItemConfig } = this
      shareConfig = shareConfig || this.shareConfig
      const {
        title,
        desc,
        link,
        imgUrl,
        success = () => {},
        cancel = () => {},
        type = '',
        dataUrl = ''
      } = shareConfig
      const _self = this
      for (let i = 0; i < shareLinsters.length; i++) {
        const method = shareLinsters[i]
        const isShare =
          method === 'onMenuShareTimeline' ||
          method === 'onMenuShareAppMessage' ||
          method === 'onMenuShareQQ' ||
          method === 'onMenuShareWeibo' ||
          method === 'onMenuShareQZone' ||
          method === 'updateAppMessageShareData' ||
          method === 'updateTimelineShareData'
        let conf = {}
        if (method === 'hideMenuItems') {
          const { menuList = [] } = hideConfig
          conf = { menuList }
          wx && wx[method](conf)
        } else if (method === 'hideAllNonBaseMenuItem') {
          const {
            hideAllNonBaseMenuItem = false
          } = hideAllNonBaseMenuItemConfig
          if (hideAllNonBaseMenuItem) {
            wx && wx[method](conf)
          }
        } else if (isShare) {
          conf = {
            ...{
              title,
              link,
              desc,
              imgUrl,
              success() {
                success({
                  method,
                  config: shareConfig
                })
                try {
                  _self.mixinShareStat({
                    channel: shareMatchKeys[method]
                  })
                } catch (e) {
                  console.log(`分享失败`, e)
                }
              },
              cancel() {
                cancel({
                  method,
                  config: shareConfig
                })
              }
            },
            ...(method === 'onMenuShareAppMessage'
              ? {
                  type,
                  dataUrl
                }
              : {})
          }
          wx && wx[method](conf)
        }
      }
    },

    setMiniProgram(watch = true) {
      let postMessage = () => {}
      // 微信小程序
      if (
        /miniProgram/i.test(navigator.userAgent) &&
        window.__wxjs_environment === 'miniprogram'
      ) {
        let loadWxJsPromise = window.wx
          ? Promise.resolve()
          : loadScript(`https://res.wx.qq.com/open/js/jweixin-1.6.0.js`)

        postMessage = () =>
          loadWxJsPromise.then(() => {
            wx.miniProgram.postMessage({
              data: {
                type: 'share',
                data: this.shareConfig
              }
            })
          })
      }
      // 支付宝小程序
      if (navigator.userAgent.indexOf('AlipayClient') > -1) {
        let loadAliPayJsPromise = window.my
          ? Promise.resolve()
          : loadScript(`https://appx/web-view.min.js`)

        postMessage = () =>
          loadAliPayJsPromise.then(() => {
            my.postMessage({
              data: {
                type: 'share',
                data: this.shareConfig
              }
            })
          })
      }

      postMessage()
      watch &&
        this.$watch(
          () => this.shareConfig,
          () => postMessage()
        )
    }
  },

  mounted() {
    // 为了兼容SSR，在mounted才执行
    this.isAutoSetBrowserShare && this.setBrowserShare()
    // this.setNativeShare()
  },

  watch: {
    wxConfig(val) {
      if (val === null) {
        return
      }
      setTimeout(() => {
        loadScript(`https://res.wx.qq.com/open/js/jweixin-1.6.0.js`).then(
          () => {
            const { shareLinsters, s } = this
            var { debug, appId, timestamp, nonceStr, signature } = val
            var _config = {
              debug, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId, // 必填，公众号的唯一标识
              timestamp, // 必填，生成签名的时间戳
              nonceStr, // 必填，生成签名的随机串
              signature, // 必填，签名，见附录1
              jsApiList: [...shareLinsters], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
              openTagList: ['wx-open-launch-app']
            }
            //微信基本配置信息
            wx.config(_config)

            wx.ready(() => {
              this.wxShareConfig()
              this.wxReady()
            })
          }
        )
      }, 500) // 500毫秒我也不知道为什么.....
    },
    shareConfig(val) {
      this.wxShareConfig(val)
    }
  }
}

export default wechatShareMixin
